import React from "react";
import { colorsConst } from "src/modules/utils/colorsConst";

type Props = {
  size?: "S" | "M";
  isColored?: boolean;
};

export const MenuPassIcon = React.memo(
  ({ size = "S", isColored = true }: Props) => {
    const outLineColor = isColored ? "#FF5C00" : colorsConst.BLACK;
    const fillColor = isColored ? outLineColor : "none";
    const pathColor = isColored ? colorsConst.WHITE : colorsConst.BLACK;
    return (
      <>
        {size === "S" ? (
          <MenuPassIconSizeS
            outLineColor={outLineColor}
            fillColor={fillColor}
            pathColor={pathColor}
          />
        ) : (
          <MenuPassIconSizeM
            outLineColor={outLineColor}
            fillColor={fillColor}
            pathColor={pathColor}
          />
        )}
      </>
    );
  }
);

type MenuPassDisableIconProps = {
  color?: string;
};

export const MenuPassDisableIcon = React.memo(
  ({ color = colorsConst.LIGHT_GRAY }: MenuPassDisableIconProps) => {
    return (
      <svg
        width="27"
        height="18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.554"
          y="1.46"
          width="24.538"
          height="15.444"
          rx="3.164"
          stroke={color}
          strokeWidth="1.712"
        />
        <path
          d="M6.196 11.761h-.87V5.949h.87v.41c.343-.343.732-.514 1.167-.514.518 0 .945.19 1.28.572.34.379.51.857.51 1.434 0 .564-.169 1.034-.507 1.41a1.63 1.63 0 0 1-1.267.561c-.441 0-.835-.176-1.183-.53v2.47Zm2.068-3.907c0-.361-.098-.655-.294-.882a.95.95 0 0 0-.75-.344c-.32 0-.578.111-.777.333-.198.221-.297.513-.297.873 0 .353.099.645.297.874a.977.977 0 0 0 .773.336c.302 0 .55-.113.746-.34.201-.227.302-.51.302-.85ZM13.402 5.948h.874v3.765h-.874v-.394c-.358.335-.743.502-1.156.502-.52 0-.95-.188-1.29-.564-.338-.384-.507-.863-.507-1.438 0-.564.169-1.035.506-1.41.338-.377.76-.565 1.268-.565.438 0 .831.18 1.18.54v-.436Zm-2.064 1.87c0 .362.097.655.29.882a.95.95 0 0 0 .75.344c.322 0 .582-.11.78-.332.199-.23.298-.52.298-.874 0-.353-.099-.644-.297-.873a.984.984 0 0 0-.774-.337.961.961 0 0 0-.75.34c-.198.23-.297.513-.297.85ZM18.194 6.59l-.718.382c-.114-.232-.254-.347-.422-.347a.286.286 0 0 0-.205.08.259.259 0 0 0-.085.202c0 .144.168.287.503.429.461.198.771.381.931.549.16.167.24.393.24.676 0 .363-.134.667-.402.912-.26.232-.575.348-.943.348-.631 0-1.079-.308-1.341-.924l.742-.344c.103.18.181.295.236.344a.538.538 0 0 0 .378.147c.294 0 .44-.134.44-.402 0-.154-.112-.299-.34-.433a12.256 12.256 0 0 0-.262-.127 24.16 24.16 0 0 1-.267-.128c-.252-.124-.43-.247-.533-.37-.132-.158-.197-.36-.197-.608 0-.327.112-.598.336-.811.23-.214.508-.321.835-.321.482 0 .84.248 1.074.746ZM22.202 6.59l-.719.382c-.113-.232-.254-.347-.421-.347a.286.286 0 0 0-.205.08.259.259 0 0 0-.085.202c0 .144.167.287.502.429.461.198.772.381.932.549.16.167.24.393.24.676 0 .363-.135.667-.403.912-.26.232-.574.348-.943.348-.631 0-1.078-.308-1.341-.924l.742-.344c.103.18.182.295.236.344a.538.538 0 0 0 .379.147c.294 0 .44-.134.44-.402 0-.154-.113-.299-.34-.433a12.256 12.256 0 0 0-.263-.127 24.16 24.16 0 0 1-.266-.128c-.253-.124-.43-.247-.534-.37-.131-.158-.197-.36-.197-.608 0-.327.112-.598.336-.811.23-.214.508-.321.835-.321.482 0 .84.248 1.075.746Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.896 12.582H2.41v1.141h19.004l-.52-1.141Zm1.292 1.141h.66l-.518-1.141h-.661l.519 1.141Zm3.049 0H23.62l-.519-1.141h2.135v1.141Z"
          fill={color}
        />
      </svg>
    );
  }
);

const MenuPassIconSizeS = React.memo(
  ({
    outLineColor,
    pathColor,
    fillColor,
  }: {
    outLineColor: string;
    pathColor: string;
    fillColor: string;
  }) => {
    return (
      <svg
        width="19"
        height="12"
        viewBox="0 0 19 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="17.6724"
          height="11"
          rx="2.52211"
          fill={fillColor}
          stroke={outLineColor}
        />
        <path
          d="M3.76414 7.87982H3.12891V3.64631H3.76414V3.94469C4.01447 3.6951 4.29868 3.57031 4.61677 3.57031C4.99509 3.57031 5.30659 3.70918 5.55128 3.98691C5.79973 4.26276 5.92395 4.61086 5.92395 5.03121C5.92395 5.44218 5.80067 5.78465 5.5541 6.05862C5.30942 6.33072 5.00074 6.46677 4.62807 6.46677C4.30621 6.46677 4.01824 6.33823 3.76414 6.08114V7.87982ZM5.2746 5.03402C5.2746 4.77131 5.20307 4.55738 5.06003 4.39224C4.9151 4.22523 4.73253 4.14172 4.51231 4.14172C4.27892 4.14172 4.08976 4.22242 3.94483 4.3838C3.7999 4.54518 3.72744 4.75723 3.72744 5.01995C3.72744 5.27704 3.7999 5.48909 3.94483 5.6561C4.08788 5.81936 4.2761 5.90099 4.50949 5.90099C4.7297 5.90099 4.91133 5.81842 5.05438 5.65329C5.20119 5.48815 5.2746 5.28173 5.2746 5.03402Z"
          fill={`${pathColor}`}
        />
        <path
          d="M9.02775 3.64631H9.66581V6.38796H9.02775V6.10085C8.76612 6.3448 8.48474 6.46677 8.18359 6.46677C7.80339 6.46677 7.48906 6.32979 7.24061 6.05581C6.99405 5.7762 6.87076 5.42716 6.87076 5.00869C6.87076 4.59773 6.99405 4.25525 7.24061 3.98128C7.48718 3.7073 7.79586 3.57031 8.16665 3.57031C8.48662 3.57031 8.77365 3.70167 9.02775 3.96439V3.64631ZM7.52012 5.00869C7.52012 5.27141 7.5907 5.48534 7.73186 5.65047C7.87679 5.81749 8.05936 5.90099 8.27958 5.90099C8.51485 5.90099 8.70495 5.8203 8.84988 5.65892C8.99481 5.4919 9.06727 5.27985 9.06727 5.02277C9.06727 4.76568 8.99481 4.55363 8.84988 4.38661C8.70495 4.22335 8.51673 4.14172 8.28522 4.14172C8.06689 4.14172 7.88432 4.22429 7.73751 4.38943C7.59258 4.55644 7.52012 4.76286 7.52012 5.00869Z"
          fill={`${pathColor}`}
        />
        <path
          d="M12.5282 4.11358L12.003 4.39224C11.9202 4.22335 11.8176 4.13891 11.6953 4.13891C11.6369 4.13891 11.5871 4.15861 11.5457 4.19802C11.5042 4.23555 11.4835 4.28434 11.4835 4.34439C11.4835 4.44948 11.6059 4.55363 11.8506 4.65684C12.1875 4.80133 12.4143 4.93457 12.531 5.05654C12.6477 5.17852 12.706 5.34272 12.706 5.54914C12.706 5.81373 12.6081 6.03517 12.4124 6.21344C12.2223 6.38233 11.9927 6.46677 11.7235 6.46677C11.2624 6.46677 10.9358 6.24253 10.7438 5.79403L11.2859 5.54351C11.3612 5.67487 11.4186 5.75837 11.4581 5.79403C11.5353 5.86534 11.6275 5.90099 11.7348 5.90099C11.9494 5.90099 12.0567 5.80341 12.0567 5.60825C12.0567 5.49566 11.9739 5.39057 11.8082 5.29299C11.7442 5.26109 11.6802 5.23012 11.6162 5.2001C11.5522 5.17008 11.4873 5.13911 11.4214 5.10721C11.237 5.01714 11.1071 4.92706 11.0318 4.83699C10.9358 4.72252 10.8878 4.57521 10.8878 4.39506C10.8878 4.15674 10.9697 3.9597 11.1335 3.80394C11.301 3.64819 11.5042 3.57031 11.7433 3.57031C12.0953 3.57031 12.3569 3.7514 12.5282 4.11358Z"
          fill={`${pathColor}`}
        />
        <path
          d="M15.4553 4.11358L14.9302 4.39224C14.8474 4.22335 14.7448 4.13891 14.6225 4.13891C14.5641 4.13891 14.5142 4.15861 14.4728 4.19802C14.4314 4.23555 14.4107 4.28434 14.4107 4.34439C14.4107 4.44948 14.5331 4.55363 14.7777 4.65684C15.1147 4.80133 15.3415 4.93457 15.4582 5.05654C15.5748 5.17852 15.6332 5.34272 15.6332 5.54914C15.6332 5.81373 15.5353 6.03517 15.3396 6.21344C15.1495 6.38233 14.9198 6.46677 14.6507 6.46677C14.1896 6.46677 13.863 6.24253 13.671 5.79403L14.2131 5.54351C14.2884 5.67487 14.3458 5.75837 14.3853 5.79403C14.4625 5.86534 14.5547 5.90099 14.662 5.90099C14.8766 5.90099 14.9838 5.80341 14.9838 5.60825C14.9838 5.49566 14.901 5.39057 14.7354 5.29299C14.6714 5.26109 14.6074 5.23012 14.5434 5.2001C14.4794 5.17008 14.4145 5.13911 14.3486 5.10721C14.1642 5.01714 14.0343 4.92706 13.959 4.83699C13.863 4.72252 13.815 4.57521 13.815 4.39506C13.815 4.15674 13.8969 3.9597 14.0606 3.80394C14.2281 3.64819 14.4314 3.57031 14.6705 3.57031C15.0224 3.57031 15.284 3.7514 15.4553 4.11358Z"
          fill={`${pathColor}`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6489 8.80078H1V9.44411H14.9422L14.6489 8.80078ZM15.5068 9.44411H15.9872L15.6939 8.80078H15.2135L15.5068 9.44411ZM17.4541 9.44411H16.5519L16.2586 8.80078H17.4541V9.44411Z"
          fill={`${pathColor}`}
        />
      </svg>
    );
  }
);

const MenuPassIconSizeM = React.memo(
  ({
    outLineColor,
    pathColor,
    fillColor,
  }: {
    outLineColor: string;
    pathColor: string;
    fillColor: string;
  }) => {
    return (
      <svg
        width="27"
        height="18"
        viewBox="0 0 27 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.55419"
          y="1.46044"
          width="24.5376"
          height="15.4437"
          rx="3.16376"
          stroke={outLineColor}
          fill={fillColor}
          strokeWidth="1.71192"
        />
        <path
          d="M6.19585 11.7615H5.32617V5.94811H6.19585V6.35783C6.53857 6.01511 6.92768 5.84375 7.36316 5.84375C7.88111 5.84375 8.30757 6.03444 8.64256 6.41581C8.98271 6.7946 9.15278 7.27261 9.15278 7.84982C9.15278 8.41415 8.98399 8.88442 8.64643 9.26064C8.31144 9.63428 7.88884 9.8211 7.37862 9.8211C6.93798 9.8211 6.54373 9.64459 6.19585 9.29156V11.7615ZM8.26377 7.85368C8.26377 7.49293 8.16585 7.19917 7.97001 6.97241C7.77159 6.74307 7.52164 6.6284 7.22015 6.6284C6.90062 6.6284 6.64165 6.7392 6.44323 6.96081C6.24481 7.18242 6.14561 7.4736 6.14561 7.83436C6.14561 8.18738 6.24481 8.47857 6.44323 8.70791C6.63907 8.93209 6.89675 9.04418 7.21628 9.04418C7.51777 9.04418 7.76644 8.9308 7.96228 8.70404C8.16327 8.47728 8.26377 8.19383 8.26377 7.85368Z"
          fill={`${pathColor}`}
        />
        <path
          d="M13.4021 5.94811H14.2756V9.71287H13.4021V9.31862C13.0439 9.65361 12.6587 9.8211 12.2464 9.8211C11.7259 9.8211 11.2955 9.63299 10.9554 9.25677C10.6178 8.87282 10.449 8.39353 10.449 7.8189C10.449 7.25457 10.6178 6.7843 10.9554 6.40808C11.2929 6.03186 11.7155 5.84375 12.2232 5.84375C12.6612 5.84375 13.0542 6.02413 13.4021 6.38489V5.94811ZM11.338 7.8189C11.338 8.17965 11.4347 8.47341 11.6279 8.70018C11.8264 8.92951 12.0763 9.04418 12.3778 9.04418C12.6999 9.04418 12.9602 8.93338 13.1586 8.71177C13.357 8.48243 13.4562 8.19125 13.4562 7.83822C13.4562 7.4852 13.357 7.19401 13.1586 6.96467C12.9602 6.74049 12.7025 6.6284 12.3855 6.6284C12.0866 6.6284 11.8367 6.74178 11.6357 6.96854C11.4372 7.19788 11.338 7.48133 11.338 7.8189Z"
          fill={`${pathColor}`}
        />
        <path
          d="M18.1944 6.58974L17.4755 6.97241C17.3621 6.74049 17.2216 6.62453 17.0541 6.62453C16.9743 6.62453 16.906 6.65159 16.8493 6.7057C16.7926 6.75724 16.7642 6.82424 16.7642 6.9067C16.7642 7.051 16.9317 7.19401 17.2667 7.33574C17.728 7.53416 18.0385 7.71711 18.1983 7.88461C18.358 8.0521 18.4379 8.27757 18.4379 8.56103C18.4379 8.92436 18.3039 9.22843 18.0359 9.47323C17.7757 9.70514 17.4613 9.8211 17.0928 9.8211C16.4615 9.8211 16.0144 9.51317 15.7515 8.8973L16.4937 8.5533C16.5967 8.73367 16.6753 8.84834 16.7295 8.8973C16.8351 8.99522 16.9614 9.04418 17.1083 9.04418C17.402 9.04418 17.5489 8.91019 17.5489 8.6422C17.5489 8.48759 17.4355 8.34328 17.2087 8.20929C17.1211 8.16548 17.0335 8.12296 16.9459 8.08173C16.8583 8.0405 16.7694 7.99799 16.6792 7.95418C16.4267 7.83049 16.2489 7.7068 16.1458 7.58312C16.0144 7.42593 15.9487 7.22365 15.9487 6.97627C15.9487 6.64901 16.0608 6.37844 16.285 6.16457C16.5143 5.95069 16.7926 5.84375 17.1198 5.84375C17.6017 5.84375 17.9599 6.09241 18.1944 6.58974Z"
          fill={`${pathColor}`}
        />
        <path
          d="M22.2019 6.58974L21.483 6.97241C21.3696 6.74049 21.2291 6.62453 21.0616 6.62453C20.9818 6.62453 20.9135 6.65159 20.8568 6.7057C20.8001 6.75724 20.7717 6.82424 20.7717 6.9067C20.7717 7.051 20.9392 7.19401 21.2742 7.33574C21.7355 7.53416 22.046 7.71711 22.2058 7.88461C22.3655 8.0521 22.4454 8.27757 22.4454 8.56103C22.4454 8.92436 22.3114 9.22843 22.0434 9.47323C21.7832 9.70514 21.4688 9.8211 21.1003 9.8211C20.469 9.8211 20.0219 9.51317 19.759 8.8973L20.5012 8.5533C20.6042 8.73367 20.6828 8.84834 20.737 8.8973C20.8426 8.99522 20.9689 9.04418 21.1158 9.04418C21.4095 9.04418 21.5564 8.91019 21.5564 8.6422C21.5564 8.48759 21.443 8.34328 21.2162 8.20929C21.1286 8.16548 21.041 8.12296 20.9534 8.08173C20.8658 8.0405 20.7769 7.99799 20.6867 7.95418C20.4342 7.83049 20.2564 7.7068 20.1533 7.58312C20.0219 7.42593 19.9562 7.22365 19.9562 6.97627C19.9562 6.64901 20.0683 6.37844 20.2924 6.16457C20.5218 5.95069 20.8001 5.84375 21.1273 5.84375C21.6092 5.84375 21.9674 6.09241 22.2019 6.58974Z"
          fill={`${pathColor}`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8959 12.582H2.41113V13.7233H21.4146L20.8959 12.582ZM22.1876 13.7233H22.8482L22.3295 12.582H21.6688L22.1876 13.7233ZM25.2368 13.7233H23.6212L23.1024 12.582H25.2368V13.7233Z"
          fill={`${pathColor}`}
        />
      </svg>
    );
  }
);

export const MenuPassCard = React.memo(
  ({ color = colorsConst.WHITE }: MenuPassDisableIconProps) => {
    return (
      <svg
        width="248"
        height="149"
        viewBox="0 0 248 149"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.8196"
          y="1.68874"
          width="244.492"
          height="145.623"
          rx="12.2185"
          stroke={color}
          strokeWidth="3.37748"
        />
        <path
          d="M75.2844 33.4375C72.2519 33.4375 69.499 34.6527 67.4853 36.6197C65.4722 34.6527 62.7193 33.4375 59.6887 33.4375C53.5324 33.4375 48.5264 38.4365 48.5264 44.5817V67.01H55.2501V44.5817C55.2501 42.1399 57.2406 40.1523 59.6861 40.1523C62.1317 40.1523 64.1222 42.1399 64.1222 44.5817V67.01H70.8459V44.5817C70.8459 42.1399 72.8364 40.1523 75.2819 40.1523C77.7275 40.1523 79.7179 42.1399 79.7179 44.5817V67.01H86.4417V44.5817C86.4467 38.4365 81.4382 33.4375 75.2844 33.4375Z"
          fill={color}
        />
        <path
          d="M109.457 40.1346C106.666 40.1346 104.044 41.2198 102.071 43.1899C98.8293 46.4273 98.1687 51.2788 100.086 55.1756L114.078 41.2041C112.657 40.5026 111.085 40.1346 109.457 40.1346ZM109.457 67.7133C104.87 67.7133 100.558 65.931 97.3146 62.6911C90.6191 56.0052 90.6191 45.1273 97.3146 38.4415C100.558 35.2028 104.87 33.418 109.457 33.418C114.045 33.418 118.356 35.2028 121.598 38.4402L123.977 40.8154L104.837 59.9272C106.256 60.6268 107.828 60.9967 109.457 60.9967C112.249 60.9967 114.871 59.9115 116.844 57.9414C117.836 56.9504 118.604 55.8005 119.128 54.5199L125.352 57.0615C124.489 59.1717 123.225 61.0658 121.598 62.6911C118.356 65.9285 114.043 67.7133 109.457 67.7133Z"
          fill={color}
        />
        <path
          d="M146.117 33.4375C137.522 33.4375 130.527 40.4223 130.527 49.0054V67.01H137.254V49.006C137.254 44.1238 141.231 40.1523 146.118 40.1523C151.007 40.1523 154.984 44.1238 154.984 49.006V67.0106H161.711V49.006C161.708 40.4204 154.713 33.4375 146.117 33.4375Z"
          fill={color}
        />
        <path
          d="M191.908 34.1328V52.1374C191.908 57.0196 187.931 60.9912 183.042 60.9912C178.153 60.9912 174.177 57.0196 174.177 52.1374V34.1328H167.451V52.1374C167.451 60.723 174.446 67.7053 183.041 67.7053C191.637 67.7053 198.631 60.7205 198.631 52.1374V34.1328H191.908Z"
          fill={color}
        />
        <path
          d="M70.8311 97.1607H68.2061V79.6273H70.8311V80.863C71.8656 79.8293 73.0401 79.3125 74.3546 79.3125C75.9179 79.3125 77.2052 79.8876 78.2163 81.0379C79.243 82.1803 79.7564 83.622 79.7564 85.3629C79.7564 87.065 79.2469 88.4834 78.228 89.6181C77.2169 90.745 75.9413 91.3084 74.4012 91.3084C73.0712 91.3084 71.8812 90.7761 70.8311 89.7113V97.1607ZM77.073 85.3746C77.073 84.2865 76.7774 83.4005 76.1863 82.7166C75.5874 82.0249 74.8329 81.679 73.9229 81.679C72.9584 81.679 72.1767 82.0132 71.5778 82.6816C70.9789 83.35 70.6795 84.2282 70.6795 85.3163C70.6795 86.3811 70.9789 87.2593 71.5778 87.951C72.1689 88.6271 72.9467 88.9652 73.9112 88.9652C74.8212 88.9652 75.5718 88.6233 76.1629 87.9393C76.7696 87.2554 77.073 86.4005 77.073 85.3746Z"
          fill={color}
        />
        <path
          d="M112.415 79.6273H115.051V90.982H112.415V89.7929C111.333 90.8033 110.171 91.3084 108.926 91.3084C107.355 91.3084 106.056 90.7411 105.029 89.6064C104.01 88.4484 103.501 87.0028 103.501 85.2697C103.501 83.5676 104.01 82.1492 105.029 81.0145C106.048 79.8798 107.324 79.3125 108.856 79.3125C110.178 79.3125 111.365 79.8565 112.415 80.9446V79.6273ZM106.184 85.2697C106.184 86.3577 106.476 87.2437 107.059 87.9277C107.658 88.6194 108.413 88.9652 109.323 88.9652C110.295 88.9652 111.081 88.631 111.68 87.9626C112.278 87.2709 112.578 86.3927 112.578 85.328C112.578 84.2632 112.278 83.385 111.68 82.6933C111.081 82.0171 110.303 81.679 109.346 81.679C108.444 81.679 107.689 82.021 107.083 82.7049C106.484 83.3966 106.184 84.2516 106.184 85.2697Z"
          fill={color}
        />
        <path
          d="M146.473 81.5625L144.303 82.7166C143.961 82.0171 143.537 81.6674 143.031 81.6674C142.79 81.6674 142.584 81.749 142.413 81.9122C142.242 82.0676 142.156 82.2697 142.156 82.5184C142.156 82.9536 142.662 83.385 143.673 83.8124C145.065 84.4109 146.002 84.9627 146.485 85.4679C146.967 85.973 147.208 86.6531 147.208 87.508C147.208 88.6038 146.803 89.5209 145.995 90.2592C145.209 90.9587 144.26 91.3084 143.148 91.3084C141.242 91.3084 139.893 90.3797 139.099 88.5222L141.339 87.4847C141.651 88.0287 141.888 88.3746 142.051 88.5222C142.37 88.8175 142.751 88.9652 143.194 88.9652C144.081 88.9652 144.524 88.5611 144.524 87.7528C144.524 87.2865 144.182 86.8513 143.498 86.4471C143.233 86.315 142.969 86.1868 142.704 86.0624C142.44 85.9381 142.172 85.8098 141.899 85.6777C141.137 85.3046 140.6 84.9316 140.289 84.5585C139.893 84.0845 139.694 83.4744 139.694 82.7283C139.694 81.7412 140.033 80.9252 140.709 80.2801C141.402 79.635 142.242 79.3125 143.229 79.3125C144.684 79.3125 145.765 80.0625 146.473 81.5625Z"
          fill={color}
        />
        <path
          d="M177.684 81.5625L175.514 82.7166C175.172 82.0171 174.748 81.6674 174.243 81.6674C174.002 81.6674 173.795 81.749 173.624 81.9122C173.453 82.0676 173.368 82.2697 173.368 82.5184C173.368 82.9536 173.873 83.385 174.884 83.8124C176.277 84.4109 177.214 84.9627 177.696 85.4679C178.178 85.973 178.419 86.6531 178.419 87.508C178.419 88.6038 178.015 89.5209 177.206 90.2592C176.42 90.9587 175.472 91.3084 174.359 91.3084C172.454 91.3084 171.104 90.3797 170.311 88.5222L172.551 87.4847C172.862 88.0287 173.099 88.3746 173.263 88.5222C173.581 88.8175 173.963 88.9652 174.406 88.9652C175.293 88.9652 175.736 88.5611 175.736 87.7528C175.736 87.2865 175.394 86.8513 174.709 86.4471C174.445 86.315 174.18 86.1868 173.916 86.0624C173.651 85.9381 173.383 85.8098 173.111 85.6777C172.349 85.3046 171.812 84.9316 171.501 84.5585C171.104 84.0845 170.906 83.4744 170.906 82.7283C170.906 81.7412 171.244 80.9252 171.921 80.2801C172.613 79.635 173.453 79.3125 174.441 79.3125C175.895 79.3125 176.977 80.0625 177.684 81.5625Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M202.999 116.219H0.130859V125.804H207.359L202.999 116.219ZM215.753 125.804H222.949L218.589 116.219H211.393L215.753 125.804ZM244.755 125.804H231.343L226.983 116.219H244.755V125.804Z"
          fill={color}
        />
      </svg>
    );
  }
);
